import { CountryListPage, CountryEditPage, CountryCreatePage } from './imports';

export const countryRoutes = [
  {
    path: 'countries',
    children: [
      { element: <CountryListPage />, index: true },
      { path: 'list', element: <CountryListPage /> },
      { path: ':id/edit', element: <CountryEditPage /> },
      { path: 'new', element: <CountryCreatePage /> },
    ],
  },
];
